import { DependenciesInjection } from "app/di/DependencyInjection";
import { CountryConfigImpl } from "../data/CountryConfigImpl";
import { ICountryConfigRepository } from "../domain/repositories/ICountryConfigRepository";
import { CountryConfigUseCase } from "../domain/useCases/CountryConfigUseCase";
import { CountryConfigViewModel } from "../presentation/viewModel/CountryConfigViewModel";
import { CountryConfigToken } from "./CountryConfigToken";

export class CountryConfigInjection {
  static initInjection() {
    DependenciesInjection.register<ICountryConfigRepository>(
      CountryConfigToken.ICountryConfigRepository,
      CountryConfigImpl,
      "otherRepo",
    );
    DependenciesInjection.register<CountryConfigUseCase>(
      CountryConfigToken.CountryConfigUseCase,
      CountryConfigUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<CountryConfigViewModel>(
      CountryConfigToken.CountryConfigViewModel,
      CountryConfigViewModel,
      "viewModel",
    );
  }

  static getCountryConfigRepo() {
    return DependenciesInjection.getRepo<ICountryConfigRepository>(
      CountryConfigToken.ICountryConfigRepository,
    );
  }

  static getCountryConfigUseCase() {
    return DependenciesInjection.getRepo<CountryConfigUseCase>(
      CountryConfigToken.CountryConfigUseCase,
    );
  }

  static getCountryConfigViewModel() {
    return DependenciesInjection.getRepo<CountryConfigViewModel>(
      CountryConfigToken.CountryConfigViewModel,
    );
  }
}
